import ready from 'document-ready';

class LayoutLoader {
	constructor(layouts){
		this.layouts = layouts;
		// once the page is loaded, check for layoutironment
		ready(() => this.parse());
		if (window.MutationObserver) {
			const observer = new MutationObserver(() => this.parse());
			observer.observe(document.documentElement, {
				childList: true,
				subtree: true
			});
		}
	}

	parse(){
		this.layouts.forEach(async layout => {
			let nodes = [];

			if( layout.selector ){
				const selector = layout.selector.split(',').map(s => {
					return s.trim()+':not([data-layout-rendered])';
				}).join(',');
				nodes = document.querySelectorAll(selector);
			}

			else if( layout.test ){
				nodes = layout.test();
			}

			if( nodes.length && layout.import ){
				Array.prototype.forEach.call( nodes, node => {
					node.setAttribute('data-layout-rendered', '');
				});
				const module = await layout.import();
				Array.prototype.forEach.call( nodes, node => {
					(module.default || module).init(node);
				});
			}
		});
	}
}
export default LayoutLoader;